<div class="contract-signing">
  <div class="contract-signing__header">
    <h2>{{ 'NEW_CONTRACTS.SIGN_CONTRACT' | i18nextEager }}</h2>
  </div>
  <section>
    <h2>{{ 'NEW_CONTRACTS.FOLLOW_STEPS' | i18nextEager }}</h2>
    <div class="contract-signing__notification">
      <div class="radios">
        <span (click)="toggleType(false)">
          <img [src]="isPaperType ? '/assets/icons/radio-default.svg' : '/assets/icons/radio-select.svg'"
            alt="{{ 'NEW_CONTRACTS.DIGITAL_SIGNATURE' | i18nextEager }}" />
          {{ 'NEW_CONTRACTS.DIGITAL_SIGNATURE' | i18nextEager }}
        </span>
        <span (click)="toggleType(true)">
          <img [src]="isPaperType ? '/assets/icons/radio-select.svg' : '/assets/icons/radio-default.svg'"
            alt="{{ 'NEW_CONTRACTS.PAPER_SIGNATURE' | i18nextEager }}" />
          {{ 'NEW_CONTRACTS.PAPER_SIGNATURE' | i18nextEager }}
        </span>
      </div>
      <div class="steps" *ngIf="isPaperType">
        <div class="block">
          <p>1. {{ 'NEW_CONTRACTS.DOWNLOAD_AND_SEND' | i18nextEager }}</p>
          <button class="secondary" [disabled]="allowAsyncContract && !hasContractFile" (click)="download()">
            <span>{{ 'NEW_CONTRACTS.DOWNLOAD' | i18nextEager }}</span>
            <img src="/assets/icons/download.svg" alt="{{ 'NEW_CONTRACTS.DOWNLOAD' | i18nextEager }}" />
          </button>
        </div>
        <div class="block" *ngIf="hasChangedBankAccount && (isUserSpanish ? true : !disabledAddSepa)">
          <p>2. {{ 'NEW_CONTRACTS.DOWNLOAD_SEPA' | i18nextEager }}</p>
          <button class="secondary" [disabled]="allowAsyncContract && !hasSepaFile" (click)="downloadSepa()">
            <span>{{ 'NEW_CONTRACTS.DOWNLOAD' | i18nextEager }}</span>
            <img src="/assets/icons/download.svg" alt="{{ 'NEW_CONTRACTS.DOWNLOAD' | i18nextEager }}" />
          </button>
        </div>
        <div class="block block__min">
          <p>3. {{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}</p>
          <div class="block block__buttons">
            <p>{{ 'NEW_CONTRACTS.CONTRACT' | i18nextEager }}</p>
            <button class="secondary" (click)="openFile('ContratoPyme')">
              <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
              <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
            </button>
          </div>
          <div class="files">
            <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
              <div class="files__item__row" *ngIf="file.tipo === 'ContratoPyme'">
                <div class="files__item__name">{{ file.nombreFichero }}</div>
                <div class="files__item__icons">
                  <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                    alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                  <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                    alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                  <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="!isBankAccounts && hasChangedBankAccount && (isUserSpanish ? true : !disabledAddSepa)">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.SEPA' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('MandatoSepa')" [disabled]="disabledAddSepa">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'MandatoSepa'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isBankAccounts && hasChangedBankAccount && (isUserSpanish ? true : !disabledAddSepa)">
            <div *ngFor="let account of bankAccountsSepa" class="block block__buttons">
              <div class="contract-signing__sepas">
                <span>{{ 'NEW_CONTRACTS.SEPA' | i18nextEager }}</span>
                <span>{{ account }}</span>
              </div>
              <button class="secondary" (click)="openFile('MandatoSepa', account)" [disabled]="disabledAddSepa">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
              <div class="files">
                <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                  <div class="files__item__row" *ngIf="file.tipo === 'MandatoSepa' && file.iban === account">
                    <div class="files__item__name">{{ file.nombreFichero }}</div>
                    <div class="files__item__icons">
                      <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                        alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                      <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                        alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                      <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isUserSpanish && !disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.IBAN-PROOF' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('Comprovativo')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'Comprovativo'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.AUTHORITATION' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('AutorizacionCanal')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'AutorizacionCanal'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="hasChangedDni">
            <div class="block block__buttons">
              <p>
                {{ (isUserSpanish ? 'NEW_CONTRACTS.DNI' : 'NEW_CONTRACTS.CITIZENSHIP_CARD') | i18nextEager }}
              </p>
              <button class="secondary" (click)="openFile('Dni')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'Dni'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isUserSpanish && !disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.PREVIOUS_INVOICE' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('FacturaReciente')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'FacturaReciente'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.ID_CARD' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('TarjetaIdentificacionFiscal')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'TarjetaIdentificacionFiscal'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.VERIFICATION_AUDIO' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('AudioVerificacion')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'AudioVerificacion'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.AUDIO_TRANSCRIPT' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('TranscripcionAudio')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'TranscripcionAudio'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="block block__buttons">
            <p>{{ 'NEW_CONTRACTS.OTHER' | i18nextEager }}</p>
            <button class="secondary" (click)="openFile('Otros')">
              <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
              <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
            </button>
          </div>
          <div class="files">
            <div class="files__item" *ngFor="let file of paperFilesList; let i = index" [attr.data-index]="i">
              <div class="files__item__row" *ngIf="file.tipo === 'Otros'">
                <div class="files__item__name">{{ file.nombreFichero }}</div>
                <div class="files__item__icons">
                  <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                    alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                  <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                    alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                  <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <input type="file" ref="file" #inputFile hidden="true" name="inputFile"
          (change)="selectFile($event.target.files)"
          accept=".txt, .mp3, .jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*,application/pdf" />

        <div *ngIf="uploadFiles" class="block">
          <p>4. {{ 'NEW_CONTRACTS.FINISH' | i18nextEager }}</p>
          <button class="secondary" (click)="openPaperDialog()">
            <span>{{ 'COMMONS.SEND' | i18nextEager }} </span>
            <img src="/assets/icons/send.svg" alt="{{ 'NEW_CONTRACTS.FINISH' | i18nextEager }}" />
          </button>
        </div>
      </div>

      <div class="steps" *ngIf="!isPaperType">
        <div class="block">
          <p>1. {{ 'NEW_CONTRACTS.DOWNLOAD_AND_SEND' | i18nextEager }}</p>
          <button class="secondary" [disabled]="allowAsyncContract && !hasContractFile" (click)="download()">
            <span>{{ 'NEW_CONTRACTS.DOWNLOAD' | i18nextEager }}</span>
            <img src="/assets/icons/download.svg" alt="{{ 'NEW_CONTRACTS.DOWNLOAD' | i18nextEager }}" />
          </button>
        </div>
        <div class="block" *ngIf="hasChangedBankAccount && (isUserSpanish ? true : !disabledAddSepa)">
          <p>2. {{ 'NEW_CONTRACTS.DOWNLOAD_SEPA' | i18nextEager }}</p>
          <button class="secondary" [disabled]="allowAsyncContract && !hasSepaFile" (click)="downloadSepa()">
            <span>{{ 'NEW_CONTRACTS.DOWNLOAD' | i18nextEager }}</span>
            <img src="/assets/icons/download.svg" alt="{{ 'NEW_CONTRACTS.DOWNLOAD' | i18nextEager }}" />
          </button>
        </div>
        <div class="block block__min">
          <p>3. {{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}</p>
          <ng-container *ngIf="!isUserSpanish && !disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.IBAN-PROOF' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('Comprovativo')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'Comprovativo'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.AUTHORITATION' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('AutorizacionCanal')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'AutorizacionCanal'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isUserSpanish && hasChangedDni">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.DNI' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('Dni')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'Dni'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isUserSpanish && !disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.PREVIOUS_INVOICE' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('FacturaReciente')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'FacturaReciente'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isUserSpanish && hasChangedDni">
            <div class="block block__buttons">
              <p>
                {{ 'NEW_CONTRACTS.CITIZENSHIP_CARD' | i18nextEager }}
              </p>
              <button class="secondary" (click)="openFile('Dni')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'Dni'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.ID_CARD' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('TarjetaIdentificacionFiscal')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'TarjetaIdentificacionFiscal'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.VERIFICATION_AUDIO' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('AudioVerificacion')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'AudioVerificacion'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!disabledButtons">
            <div class="block block__buttons">
              <p>{{ 'NEW_CONTRACTS.AUDIO_TRANSCRIPT' | i18nextEager }}</p>
              <button class="secondary" (click)="openFile('TranscripcionAudio')">
                <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
                <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
              </button>
            </div>
            <div class="files">
              <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
                <div class="files__item__row" *ngIf="file.tipo === 'TranscripcionAudio'">
                  <div class="files__item__name">{{ file.nombreFichero }}</div>
                  <div class="files__item__icons">
                    <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                      alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                    <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                      alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                    <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="block block__buttons">
            <p>{{ 'NEW_CONTRACTS.OTHER' | i18nextEager }}</p>
            <button class="secondary" (click)="openFile('Otros')">
              <span>{{ 'NEW_CONTRACTS.ATTACH' | i18nextEager }}</span>
              <img src="/assets/icons/upload.svg" alt="{{ 'NEW_CONTRACTS.DOC_ATTACHMENT' | i18nextEager }}" />
            </button>
          </div>
          <div class="files">
            <div class="files__item" *ngFor="let file of digitalFileList; let i = index" [attr.data-index]="i">
              <div class="files__item__row" *ngIf="file.tipo === 'Otros'">
                <div class="files__item__name">{{ file.nombreFichero }}</div>
                <div class="files__item__icons">
                  <img class="cursor-pointer" src="/assets/icons/download_red.svg" (click)="downloadFile(file)"
                    alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
                  <img class="cursor-pointer" src="/assets/icons/deleteRed.svg" (click)="deleteFile(i)"
                    alt="{{ 'COMMONS.ICON_DELETE_FILE' | i18nextEager }}" />
                  <img *ngIf="file.sent" src="/assets/icons/ok.svg" alt="{{ 'COMMONS.SENT' | i18nextEager }}" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <input type="file" ref="file" #inputFile hidden="true" name="inputFile"
          (change)="selectFile($event.target.files)"
          accept=".txt, .mp3, .jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*,application/pdf" />

        <div *ngIf="isUserSpanish" class="block">
          <p>4. {{ 'NEW_CONTRACTS.FINISH' | i18nextEager }}</p>
          <button class="secondary" [disabled]="allowAsyncContract && !finishCreateFiles" (click)="openDigitalDialog()">
            <span>{{ 'COMMONS.SEND' | i18nextEager }} </span>
            <img src="/assets/icons/send.svg" alt="{{ 'NEW_CONTRACTS.FINISH' | i18nextEager }}" />
          </button>
        </div>

        <div *ngIf="!isUserSpanish && uploadFilesDigital" class="block">
          <p>4. {{ 'NEW_CONTRACTS.FINISH' | i18nextEager }}</p>
          <button class="secondary" (click)="openDigitalDialog()">
            <span>{{ 'COMMONS.SEND' | i18nextEager }} </span>
            <img src="/assets/icons/send.svg" alt="{{ 'NEW_CONTRACTS.FINISH' | i18nextEager }}" />
          </button>
        </div>
      </div>
    </div>
  </section>
</div>